// braintree-web has a known race where a hosted-fields event (delivered async
// via postMessage) can fire after the instance has already been torn down
// (e.g. the user navigates back off the payment step mid-interaction). The
// SDK stubs every method on a torn-down instance to throw "<method> cannot be
// called after teardown", which is benign - the instance and DOM are already
// gone, nothing is corrupted. Filter it out.
export function braintreeTeardownRace(event, hint) {
  const error = hint?.originalException;
  return !(
    error?.name === 'BraintreeError' &&
    error?.message?.includes?.('cannot be called after teardown')
  );
}
